import { Alert, Button, Flex } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { TOUCH } from "./touch.ts"
import type { Outcome } from "./types.ts"
import { useOnePress } from "./use-one-press.ts"
import { ask } from "./use-signing.ts"

interface Props {
  download(): Promise<Outcome<unknown>>
  label: string
  failedText?: string
  compact?: boolean
}

// Each download is audited, so it asks the server rather than reusing the blob on the page.
export function DownloadCopy({
  download,
  label,
  failedText,
  compact = false
}: Props) {
  const { t } = useTranslation()
  const [failed, setFailed] = useState(false)
  const { busy, run } = useOnePress()

  const save = () =>
    run(async (sending) => {
      setFailed(false)
      sending()
      const outcome = await ask(download)
      setFailed(!outcome.ok)
    })

  return (
    <Flex vertical gap={8}>
      {failed && (
        <Alert
          type="error"
          showIcon
          message={failedText ?? t("signing.document.failed")}
        />
      )}
      <Button
        size={compact ? "middle" : "large"}
        loading={busy}
        onClick={() => void save()}
        style={compact ? undefined : TOUCH}
      >
        {label}
      </Button>
    </Flex>
  )
}
